<template>
  <div>
    <v-dialog
      v-model="regionsDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar>
          <v-btn icon @click="regionsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Регионы для текущего продукта</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <template v-if="regionsDialog">
            <Geo :GeoID="ident"></Geo>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-data-table
      dense
      :headers="headers"
      :items="desserts"
      :search="search"
      class="elevation-1"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :items-per-page="-1"
      @update:sort-by="OnSortBy($event)"
      @update:sort-desc="OnSortDesc($event)"
      @update:items-per-page="OnUpdateProductItemsPerPage($event)"
    >
      <!-- :items-per-page.sync="updateProductItemsPerPage" -->
      <template v-slot:top>
        <v-toolbar flat color="white">
          <!-- <v-toolbar-title>Банковские продукты</v-toolbar-title> -->
          <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
          <!-- <v-spacer></v-spacer> -->
          <v-text-field
            v-model="search"
            append-icon="search"
            clearable
            label="Поиск ..."
            single-line
            hide-details
            @change="OnChangeSearch($event)"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn class="mb-2" @click="AddProduct"
            ><v-icon left>add</v-icon>Добавить продукт</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:item.name="{ item }">
        <h4>{{ item.name }}</h4>
        <span>{{ moment(item.updated_at).format("DD.MM.YYYY HH:mm") }}</span>
      </template>
      <template v-slot:item.rates_table_factor_count="{ item }">
        <template v-if="item.rates_table_factor_count">
          <v-chip
            x-small
            :color="getColor(item.rates_table_factor_count)"
            class="white--text"
            >{{ getBool(item.rates_table_factor_count) }}</v-chip
          >
        </template>
        <template v-else>
          <v-chip x-small :color="getColor(item.rates_table_factor_count)">{{
            getBool(item.rates_table_factor_count)
          }}</v-chip>
        </template>
      </template>
      <template v-slot:item.active="{ item }">
        <template v-if="item.active === 'Да'">
          <v-chip x-small color="red" class="white--text"> Да </v-chip>
        </template>
        <template v-else>
          <v-chip x-small color="transparent"> Нет </v-chip>
        </template>
      </template>
      <template v-slot:item.website="{ item }">
        <span v-for="site in item.website" :key="site.id">{{ site.name }}</span>
      </template>
      <template v-slot:item.old="{ item }">
        <template v-if="item.old === 'Да'">
          <v-chip x-small color="red" class="white--text"> Да </v-chip>
        </template>
        <template v-else>
          <v-chip x-small color="transparent"> Нет </v-chip>
        </template>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> edit </v-icon>
        <v-icon small class="mr-2" @click="showTariffsTable(item.id)">
          settings
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="showGeo(item.id)"
          v-if="!checkRole(roleObj.bank)"
        >
          place
        </v-icon>
        <v-icon small @click="deleteItem(item)"> delete </v-icon>
      </template>
    </v-data-table>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      bottom
      color="deep-purple accent-4"
    ></v-progress-linear>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Geo from "./geo.vue";
import { roleObj } from "../../plugins/roles";
import moment from "moment";
export default {
  components: {
    Geo: Geo,
  },
  data: () => ({
    roleObj,
    moment,
    sortBy: "bank_license",
    sortDesc: true,
    updateProductItemsPerPage: 15,
    loading: false,
    search: "",
    dialog: false,
    regionsDialog: false,
    ident: null,
    headers: [
      {
        text: "id",
        align: "left",
        sortable: true,
        value: "id",
      },
      {
        text: "Название",
        align: "left",
        sortable: false,
        value: "name",
      },
      { text: "Банк", value: "bank_name" },
      { text: "Лицензия", value: "bank_license" },

      { text: "Тарификатор", value: "rates_table_factor_count" },
      { text: "Активный", value: "active" },
      { text: "Сайт", value: "website" },
      { text: "Действия", value: "action", sortable: false, align: "center" },
    ],
    //desserts: [],
  }),

  computed: {
    desserts() {
      return this.$store.getters.getProductsCS.map((n) => ({
        ...n,
        active: n.active ? "Да" : "Нет",
        old: n.old ? "Да" : "Нет",
      }));
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    //this.initialize()
    this.sortBy = this.$store.getters.getSortCS;
    this.sortDesc = this.$store.getters.getSortDescCS;
    this.search = this.$store.getters.getSearchCS;
    this.updateProductItemsPerPage = this.$store.getters.getProductItemsPerPage;
  },

  methods: {
    OnChangeSearch(evt) {
      this.$store.commit("SET_SEARCH_CS", evt);
    },

    OnSortBy(evt) {
      this.sortBy = evt;
      this.$store.commit("SET_SORT_CS", evt);
    },

    OnSortDesc(evt) {
      this.sortDesc = evt;
      this.$store.commit("SET_SORT_DESC_CS", evt);
    },

    OnUpdateProductItemsPerPage(evt) {
      this.updateProductItemsPerPage = evt;
      this.$store.commit("SET_PRODUCTS_PER_PAGE_CS", evt);
    },

    showTariffsTable(id) {
      this.loading = true;
      this.$store
        .dispatch("GetCalcTariffSettingsCS", id)
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "calctariff" });
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    getBool(val) {
      if (val) return "Да";
      else return "Нет";
    },
    getColor(color) {
      if (color) return "red";
      return "transparent";
    },

    AddProduct() {
      this.loading = true;
      this.$store
        .dispatch("addProductCS")
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "addproduct" });
        })
        .catch((error) => {
          this.loading = false;
        });
    },

    editItem(item) {
      // this.editedIndex = this.desserts.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      // this.dialog = true

      //this.$router.push({ name: "editproduct" });
      this.loading = true;

      this.$store
        .dispatch("getProductCS", item.id)
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "editproduct" });
        })
        .catch((error) => {
          this.loading = false;
        });
    },

    deleteItem(item) {
      Swal.fire({
        icon: "error",
        title: "Удалить продукт",
        text: "Вы действительно хотите удаленить продукт? Операцию нельзя отменить!",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "green",
        confirmButtonText: "Удалить",
        cancelButtonText: "Отменить",
        preConfirm: async () => {
          await this.$store.dispatch("deleteProductCS", item.id);
        },
      });
    },
    showGeo(id) {
      this.ident = id;
      this.regionsDialog = true;
    },
  },
};
</script>
